var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { StackedDualBarChart, arrayUtils } from "../../../Charts";
import { Loader } from "../../../components/Elements/Loader";
import { t } from "../../../I18N";

export const countriesTemplate = '58b2f3a35d59f31e1345b480';
export const countryKey = 'pa_s';

class CejilChart extends Component {
  componentDidMount() {
    this.props.getData.call(this).then(([groupedResults, setA, setB]) => {
      this.setState({ groupedResults, setA, setB });
    });
  }

  render() {
    let output = /*#__PURE__*/_jsx(Loader, {});

    if (this.state && this.state.groupedResults) {
      const { aggregations } = this.state.groupedResults;
      const countriesData = this.props.thesauris.find(
      (thesaury) => thesaury.get('_id') === countriesTemplate);


      let data = arrayUtils.sortValues(
      aggregations.all[countryKey].buckets.
      filter((country) => country.filtered.doc_count && country.key !== 'any').
      map((_country) => {
        const country = _country;
        const foundCountry = countriesData.get('values').find((v) => v.get('id') === country.key);
        country.label = foundCountry ?
        foundCountry.get('label') :
        t('System', 'No Value', null, false);
        country.results = country.filtered.doc_count;
        return country;
      }));


      data = this.props.prepareData.call(this, data, this.state.setA, this.state.setB);

      output = /*#__PURE__*/
      _jsx("div", { className: "item item-chart" }, void 0, /*#__PURE__*/
      _jsx("p", {}, void 0, this.props.label), /*#__PURE__*/
      _jsx(StackedDualBarChart, { data: data, chartLabel: this.props.label }));


    }

    return /*#__PURE__*/(
      _jsx("div", { className: "item-group-charts", style: { paddingTop: '15px', paddingRight: '15px' } }, void 0,
      output));


  }
}

CejilChart.defaultProps = {
  label: null
};








export default CejilChart;